import { Config } from '../scripts/index';
import { GROUP_BOOKINGTYPE } from './constants';
const queryString = window.location.search;
const urlParams = new URLSearchParams(queryString);
const language = urlParams.get('language');

const languageParam = language ? `&language=${language}` : '';
const replaceDiacriticsToUnicode = (storeReference) =>
    storeReference.normalize('NFKD').replace(/[^\w\s.-_/]/g, '');


// Onclick function that sets modal type for buttons
function getBookingUrl(user, store) {
    const { sfscEmployeeId } = user;

    const { BOOKING_URL, SHOPPING_SERVICE_ID } = Config;

    const { storeCodeC, name, locationCode } = store;
    const analyticsParams = `&ss-medium=bt_panel&ss-source=expert_${name}`
    const locationParam = locationCode
        ? `&location-code=${locationCode}`
        : `&store-id=${storeCodeC}`;

    return `${BOOKING_URL}/?screen=timeslot&employee-id=${sfscEmployeeId}${locationParam}${analyticsParams}`;
}

export default getBookingUrl;
